<template>
  <div ref="history" class="history p-3 h-100">
    <h3 v-if="smallScreen" class="mb-4">История заказа</h3>
    <div 
      class="history__item" 
      v-for="(item, index) in data" 
      :key="index"
    >
      <template v-if="isCall(item)">
        <div class="call-block">
          <span class="font-weight-bold">{{ userNameId(item.user_id) }}</span>
          <span>сделал(a) звонок:</span>
          <span class="font-weight-bold">{{ item.statuses }}</span>
          <div :class="[item.yeastar_phone_number != '9999999999' ? 'mb-2':'mb-0']" v-if="item.comment">
            <div class="bg-light border p-2 rounded overflow-auto">
              {{ item.comment }}
            </div>
          </div>
          <div>
            <div 
              class="history__item_date d-flex align-items-center"
              v-if="item.yeastar_phone_number != '9999999999'"
            >
              <b-icon-clock font-scale="1.4" class="mr-1" />
              Звонок длился
              <template v-if="item.call_length < 1">
                менее минуты
              </template>
              <template v-else>
                {{
                  numberDeclension(item.call_length, ["минуту", "минуты", "минут"])
                }}
              </template>
            </div>
            <span class="history__item_date">{{ item.created_at }}</span>
          </div>
        </div>
      </template>

      <template v-if="isComment(item) && item.comment">
        <Comment
          :id-comment="item.id"
          :created-at="item.created_at"
          :user-id="item.creator_user_id"
          :text="item.comment"
          :parent_comment="item.parent_comment"
          :files="item.files"
          :informed_users="item.informed_users"
          :author-edit-seconds-left="item.author_edit_seconds_left || 0"
          @editComment="$emit('editComment', item)"
          @replyComment="$emit('replyComment', item)"
          @remove="removeComment"
          @scrollToRepliedComment="$emit('scrollToRepliedComment', item.parent_comment.id)"
        />
      </template>

      <template v-if="isServiceComment(item) && item.comment">
        <div class="service-comment-block">
          <div class="service-comment-block-name" v-if="order && order.services"><b-badge variant="secondary" pill title="Комментарий оставлен в услуге">{{ findServiceName(item.targetable_id) }}</b-badge></div>
          <Comment
            :id-comment="item.id"
            :created-at="item.created_at"
            :user-id="item.creator_user_id"
            :text="item.comment"
            :parent_comment="item.parent_comment"
            :files="item.files"
            :informed_users="item.informed_users"
            @scrollToRepliedComment="$emit('scrollToRepliedComment', item.parent_comment.id)"
          />
        </div>
      </template>

      <template v-if="isStatus(item)">
        <div class="status-block">
          <p>Изменился статус заказа на
            <span class="font-weight-bold">{{ item.reference_service_property_name }}</span>
          </p>
          <div class="history__item_date">
            <template v-if="item.user_id">{{ userNameId(item.user_id) }} / </template>
            {{ item.created_at }}
          </div>
          <button
            v-if="isAdmin"
            class="history-delete-button text-danger"
            @click="prepareDeleteComment(item)"
          ><i class="fa fa-times" aria-hidden="true"></i></button>
        </div>
      </template>

      <template v-if="isSubStatus(item)">
        <div class="substatus-block">
          <p>Добавлена метка
            <span class="font-weight-bold">{{ item.substatus_local }}</span>
          </p>
          <div class="history__item_date">{{ item.created_at }}</div>
        </div>
      </template>
    </div>
    <b-modal
      @hidden="closeModalDeleteHistoryTask"
      :visible="isModalDeleteHistoryStatus"
      hide-footer
      body-class="p-0"
      centered
      id="history-delete-modal"
      title="Уверены ли вы в удалении статуса из истории?"
    >
      <template>
        <div class="p-3 d-flex justify-content-center align-items-center">
          <button
            class="btn btn-outline-green mr-5"
            @click="deleteComment">Да</button>
          <button
            class="btn btn-outline-red"
            @click="closeModalDeleteHistoryTask">Нет</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Comment from '@components/comments/Comment.vue';

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    order: {
      type: Object,
      required:false,
    },
    order_id: {
      type: String,
      required: true
    }
  },

  components: {
    Comment,
  },

  data() {
    return {
      firstLoad: true,
      editCommentStatus: false,
      isModalDeleteHistoryStatus: false,
      deletingComment: null,
    };
  },

  computed: {
    smallScreen() {
      return this.$mq === 'sm' || this.$mq === 'md'
    },
    ...mapGetters('auth', ['currentUser']),
    isAdmin() {
      return this.currentUser.role.includes('administrator');
    },
  },

  watch: {
    data: {
      handler() {
        if (this.editCommentStatus) return;
        this.$nextTick(() => {
          this.firstLoad ? this.scroll("auto") : this.scroll("smooth");
          this.firstLoad = false;
        });
      },
      immediate: true,
    },
  },

  methods: {
    isCall(item) {
      const exceptions = ["progress"];
      if (
        item.history_type === "user_call" &&
        exceptions.includes(item.statuses.toLowerCase())
      ) {
        return false;
      }
      return item.history_type === "user_call";
    },

    isComment(item) {
      return item.history_type === "user_comment";
    },
    isServiceComment(item) {
      return item.history_type === "user_service_comment";
    },
    
    isStatus(item) {
      return item.history_type === "order_status";
    },

    isSubStatus(item) {
        return item.history_type === "order_substatus";
    },

    scroll(smooth) {
      this.$refs.history.scrollTo({
        top: this.$refs.history.scrollHeight,
        behavior: smooth,
      });
    },

    removeComment(id) {
      this.editCommentStatus = true;
      this.$api.order.removeComment(id).then(() => {
        this.$emit('updateData');
        setTimeout(() => {
          this.editCommentStatus = false;
        }, 500);
      }).catch(() => {
        // Ошибку (например, истекло время на удаление) показывает axios-интерцептор
        this.editCommentStatus = false;
        this.$emit('updateData');
      });
    },

    findServiceName($order_service_id) {
      let findedElement = this.order.services.find(service => {
        return service.pivot.id === $order_service_id
      });

      if (!findedElement) {
        return 'Общая';
      }

      return findedElement.name;
    },
    prepareDeleteComment(item) {
      this.deletingComment = item;
      this.isModalDeleteHistoryStatus = true;
    },
    deleteComment() {
      api.call('delete', `/api/orders/status-history/${this.deletingComment.id}`)
        .then(() => { 
          this.$emit('updateData');
          this.isModalDeleteHistoryStatus = false;
        })
        .catch(e => console.log(e))
    },
    closeModalDeleteHistoryTask() {
      this.deletingComment = null;
      this.isModalDeleteHistoryStatus = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.history {
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    border-radius: 0px !important;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 0px !important;
  }

  &__item {
    margin-bottom: 15px;

    .comment {
      margin: 0 !important;
      min-width: 400px;
      @media screen and (max-width: 991px) {
        min-width: 100%;
      }
    }
    .status-block {
      position: relative;
      border-left: 3px solid #0d6247;
      padding-left: 8px;
    }
    .substatus-block {
      border-left: 3px solid #E37926;
      padding-left: 8px;
    }
    .service-comment-block {
      position: relative;
      border-left: 3px solid #CCCCCC;
      padding-left: 8px;
    }
    .service-comment-block-name {
      position: absolute;
      top: 0px;
      right: 5px;
      z-index: 5;
    }
    .service-comment-block-name .badge {
      cursor: pointer;
    }
    .call-block {
      margin-left: 11px;
    }
    &_date {
      color: #9e9e9e;
      font-size: 10px;
    }
  }
  ::v-deep p {
    margin-bottom: 0;
  }
  &-delete-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 2px;
    border: none;
    outline: none;
    background-color: transparent;
  }
}
</style>
